var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.brand],staticStyle:{"margin-top":"0 !important"},attrs:{"id":"main"}},[_c('router-view',{staticClass:"main_v3 ign_main"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }